/*global jQuery, SimpleBar, YT, DM, vidible*/
(function ($) {
    'use strict';

    $.fn.topVideos = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideos');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideos.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideos', (ctrl = new TopVideos(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideos.defaults = { };

    function TopVideos(element, options) {
        this.init(element, options);
    }

    // Supported players
    TopVideos.players = {
        youtube:     {plugin: 'topVideoYoutube',     preload: true},
        vidible:     {plugin: 'topVideoVidible',     preload: false},
        dailymotion: {plugin: 'topVideoDailyMotion', preload: true},
        unknown:     {plugin: 'topVideoUnknown',     preload: false}
    };

    TopVideos.lastUid = 0;


    TopVideos.prototype = {
        constructor: TopVideos,

        // Properties
        uid: 0, // Unique id attached to each top video instance
        $playbackArea: null,
        $videosList: null,
        $scrollAnchor: null,
        $thumbsScrollContent: null,
        simpleBar: null,

        // Contains current player
        player: null,

        autoClickDirty: false,
        scrollingDirty: false,
        nextPlaysMuted: true,
        firstPreloaded: false,

        // Methods
        init: function (element, options) {
            this.uid = TopVideos.lastUid++;
            this.options = options;
            this.$element = $(element);
            this.$playbackArea = this.$element.find('.top-videos__play');
            this.$videosList = this.$element.find('.top-videos__list__content');

            this.simpleBar = new SimpleBar(this.$videosList[0]);
            this.$thumbsScrollContent = $(this.simpleBar.getContentElement());

            // Create reused method closures
            this._onWindowBlur = this._onWindowBlur.bind(this);
            this._onPlayerReady = this._onPlayerReady.bind(this);
            this._onPlayerEnded = this._onPlayerEnded.bind(this);
            this._onEmbedFirstClick = this._onEmbedFirstClick.bind(this);

            // Handle resize logic
            this._validateSize();
            $(window).on('resize', this._validateSize.bind(this));

            // Listeners
            this.$videosList.on('click', '.card a', this._onPlayVideoClick.bind(this));
            this.$videosList.on('wheel', this._onMouseWheel.bind(this));
            this.$element.on('click', '[data-top-videos]', this._onDataAction.bind(this));
            this.$thumbsScrollContent.on('scroll', this._onThumbsScrollChange.bind(this));

            this._attachScrollInAnchor();
        },

        // Cleans global listeners
        dispose: function() {
            if (this.player) {
                this.destroy();
                this.player = null;
            }
        },

        isNarrow: function() {
          return this.$element.hasClass('top-videos--narrow');
        },

        /**
         * @param {string} url
         * @param {boolean} autoPlay
         */
        playVideo: function (url, autoPlay) {
            var $playbackArea = this.$playbackArea;
            var urlSeparator = url.lastIndexOf('?') >= 0 ? '&' : '?';

            if (autoPlay) {
                // Helpful for unknown player types
                url += urlSeparator + 'autoplay_in_view=50';
                urlSeparator = '&';
            }

            // Vidible mute JS method crashes the player when autoplay is on. We must always pass mute=1
            // This is not needed for DailyMotion and Youtube which will handle this fine.
            if (this.nextPlaysMuted) {
                url += urlSeparator + 'mute=1';
                // urlSeparator = '&';
            }

            $playbackArea.data('video-meta', {
               url: url, autoPlay: autoPlay
            });

            this._loadVideoSnippet(url).then(function (snippet) {
                $playbackArea.css('opacity', 0);
                $playbackArea.html(snippet.html).promise().done(this._onEmbedLoaded.bind(this, snippet));
                $playbackArea.animate({opacity: 1});
            }.bind(this));
        },


        /**
         * Hooks a vidible player. Called externally from vidible.js
         */
        hookVidible: function(player) {
            this.player.activate(player);
        },

        /**
         * @private
         * @param {{html: string, type: string, plugin: string, supportsPreload: boolean}} snippet
         */
        _onEmbedLoaded: function(snippet) {
            var $embed = this.$playbackArea.find('.embed-container');
            var plugin = $.fn[snippet.plugin];
            var options = {
                onReady: this._onPlayerReady,
                onEnded: this._onPlayerEnded,
                disablePlay: snippet.type === 'vidible',
                disableMute: snippet.type === 'vidible' // Vidible mute JS method crashes the player when autoplay is on
            };

            if (this.player) {
                this._validateMuteState();

                // TODO: Reuse the player instance for smoother experience
                // We can do that when the next video is the same type
                this.player.destroy();
                this.player = null;
            }

            this.player = plugin.call($embed, options).data(snippet.plugin);

            if (this.scrollingDirty) {
                this._onVisibleEnough(true);
            } else if (this.nextPlaysMuted) {
                this.player.mute();
            }
        },

        /**
         * @param url
         * @return {JQuery.PromiseBase<{html: string, type: string, plugin: string, supportsPreload: boolean}>}
         * @private
         */
        _loadVideoSnippet: function(url) {
            // TODO: Add cache support
            return $.get('/video-embed' + url).then(function (content) {
                // Get embed markup without executing scripts
                var markup = $.parseHTML(content, document, false);
                var embedType = this._detectEmbedType(markup);
                var definition = TopVideos.players[embedType];

                return {
                    html: content,
                    type: embedType,
                    plugin: definition.plugin,
                    supportsPreload: definition.preload
                };
            }.bind(this));
        },

        /** @private */
        _detectEmbedType: function(container) {
            var $playbackArea = $(container);
            var $youtubePlayer = $playbackArea.find('#ytplayer');
            var $iframe = $playbackArea.find('iframe');
            var playerType = 'unknown';

            if ($youtubePlayer.length) {
                playerType = 'youtube';
            } else if ($iframe.filter('[src*="video.huffingtonpost.it"]').length) {
                playerType = 'italy';
            } else if ($iframe.data('provider') === 'dailymotion') {
                playerType = 'dailymotion';
            } else if ($playbackArea.find('[data-provider="vidible"]').length) {
                playerType = 'vidible';
            }

            console.log('Top Videos - embed type', playerType);
            return playerType;
        },

        /** @private */
        _onPlayerReady: function() {
            var $embedContainer = this.$playbackArea.find('.embed-container');
            var player = this.player;

            // Make sure the player has actual dimensions
            if (player.playerHeight > 0) {
                var isSquare = player.playerWidth === player.playerHeight;
                var contentHeight = isSquare ? player.playerHeight : '';

                this.$playbackArea.css('min-height', contentHeight);
                this.$playbackArea.toggleClass('square-video', isSquare);

                $embedContainer.css('padding-bottom', contentHeight);
            }
        },

        /** @private */
        _listenForPlayerClick: function (enabled) {
            if (enabled) {
                // Detect player clicks.
                window.addEventListener('blur', this._onWindowBlur); // When there's an iframe that's the only way to detect
                // Capture phase increases our chances of catching the click before the content
                this.$playbackArea[0].addEventListener('click', this._onEmbedFirstClick, true);
            } else {
                window.removeEventListener('blur', this._onWindowBlur);
                this.$playbackArea[0].removeEventListener('click', this._onEmbedFirstClick, true);
            }
        },

        /** @private */
        _onPlayerEnded: function(newState) {
            this._autoPlayNext();
        },

        /** @private */
        _autoPlayNext: function() {
            var videoUrl = this._activateCard('next', true);

            if (videoUrl) {
                this.triggerHandler('autoPlay', videoUrl);
            }
        },

        /** @private */
        _validateMuteState: function() {
            if (this.nextPlaysMuted) {
                this.nextPlaysMuted = this.player.isMuted;
            }
        },

        /** @private */
        _validateSize: function() {
            var $element = this.$element;
            var elementWidth = this.$element.outerWidth();

            if (elementWidth > 1024) {
                // Wide version
                $element.removeClass('top-videos--narrow').addClass('top-videos--wide');
            } else {
                // Narrow version
                $element.removeClass('top-videos--wide').addClass('top-videos--narrow');
            }
        },

        /** @private */
        _onPlayVideoClick: function (event) {
            this.nextPlaysMuted = false; // User requested next video. Don't play it muted.
            event.preventDefault();
            var videoUrl = this._activateCard($(event.target).closest('.card'), true);

            if (videoUrl) {
                this.triggerHandler('clickPlay', videoUrl);
                this.triggerHandler('cardClick', event.target);
            }

            return false;
        },

        /** @private */
        _onMouseWheel: function(event) {
            if (this.isNarrow()) {
                // Turn on horizontal scrolling with mouse wheel
                var delta = event.originalEvent.deltaY;
                var contentElement = this.simpleBar.getContentElement();

                contentElement.scrollLeft += delta;
                event.preventDefault();
                event.stopPropagation();
            }
        },

        /** @private */
        _onDataAction: function(e) {
            var action =  $(e.currentTarget).data('top-videos');
            var scrollChange = 0;

            switch (action) {
                case 'prev':
                    scrollChange = -80;
                    break;
                case 'next':
                    scrollChange = 80;
                    break;
            }

            if (scrollChange !== 0) {
                var scrollContent = this.simpleBar.getContentElement();
                var $scrollContent = $(scrollContent);

                $scrollContent.stop(true).animate({
                    scrollLeft: scrollContent.scrollLeft + scrollChange
                }, 200);
            }
        },

        /** @private */
        _onThumbsScrollChange: function(e) {
            var scrollContent = e.currentTarget;
            var viewportSize = scrollContent.clientWidth;
            var scrollSize = scrollContent.scrollWidth;
            var atEnd = scrollSize - viewportSize === scrollContent.scrollLeft;
            var atStart = scrollContent.scrollLeft === 0;

            this.$element.toggleClass('top-videos--scroll-start', atStart);
            this.$element.toggleClass('top-videos--scroll-end', atEnd);
        },

        /**
         * @param {string|jQuery} element
         * @returns jQuery
         * @private
         */
        _elementToCard: function(element) {
            switch (element) {
                case 'first':
                    return this.$cards.first();
                case 'next':
                    return this.$activeCard.next('.card');
                default:
                    return $(element).closest('.card');
            }
        },

        get $activeCard() {
            return this.$videosList.find('.card--active');
        },

        get $cards() {
            return this.$videosList.find('.card');
        },

        /**
         * @private
         */
        _attachScrollInAnchor: function() {
            this.$scrollAnchor = $('<div class="top-videos__scroll-in-anchor"></div>').appendTo(this.$element);

            this._preloadFirst().then(function (preloaded) {
                if (this.$scrollAnchor.sonar()) {
                    this._onVisibleEnough(preloaded);
                } else {
                    this.$scrollAnchor.on('scrollin', this._onVisibleEnough.bind(this, preloaded));
                }
            }.bind(this));
        },

        /**
         * @param {boolean} usePlayer if not using player video will reload on missing this.player instead of waiting.
         * @private
         */
        _onVisibleEnough: function(usePlayer) {
            // We care only once for this event.
            this.$scrollAnchor.off('scrollin');

            var $element = this.$element;
            var playFirst = $element.data('play-first');
            var autoplay = ['forceOn', 'default'].indexOf(playFirst) >= 0;
            var mute = $element.data('mute-first') === 1;

            this.scrollingDirty = true;

            if (this.player) {
                this.scrollingDirty = false;

                if (autoplay) {
                    if (mute) {
                        // Always play the first one muted
                        this.player.mute();
                    }

                    // Update video meta to match autoplay logic
                    var videoMeta = this.$playbackArea.data('video-meta');
                    videoMeta.autoPlay = true;

                    if (this.player.supportsPlay) {
                        // Logic will apply only for know player types.
                        // Unknown player doesn't auto play.
                        this.player.play();
                    }

                    this.triggerHandler('autoPlayFirst', videoMeta.url);
                } else {
                    // Autoplay is not enabled. Detect first video click
                    this._listenForPlayerClick(true);
                }
            } else if (!usePlayer) {
                this.scrollingDirty = false;

                if (autoplay) {
                    if (mute) {
                        this.nextPlaysMuted = true;
                    }

                    // Don't use existing player. Just reload the whole video
                    var videoUrl = this._activateCard('first', true);
                    this.triggerHandler('autoPlayFirst', videoUrl);
                } else {
                    // Display video player html on the page
                    this._activateCard('first', false);
                }
            }
        },

        /**
         * @param {string} type
         * @param {*} data
         */
        triggerHandler: function (type, data) {
            this.$element.triggerHandler(type, data);
        },

        /**
         * @private
         * @return {string}
         */
        _cardVideoUrl: function (element) {
            var $card = this._elementToCard(element);
            var $link = $card.find('a').first();

            return $link.attr('href');
        },

        /**
         * @return {JQueryPromise} Resolved with true if preload is supported and a player instance will be created
         * @private
         */
        _preloadFirst: function () {
            var $card = this._elementToCard('first');
            var def = $.Deferred();

            if ($card.length) {
                var videoUrl = this._cardVideoUrl($card);
                var provider = $card.data('provider');
                var snippet = TopVideos[provider];

                // Avoid preloading if we can extract preload state from the inline provider
                if (!snippet || snippet.preload) {
                    this._loadVideoSnippet(videoUrl).then(function (snippet) {
                        if (snippet.supportsPreload) {
                            this._activateCard($card, false);
                            def.resolve(true);
                        } else {
                            def.resolve(false);
                        }
                    }.bind(this));
                } else {
                    def.resolve(false);
                }
            } else {
                def.resolve(false);
            }

            return def.promise();
        },

        /**
         * @param element
         * @param {boolean} autoPlay
         * @return {string}
         * @private
         */
        _activateCard: function (element, autoPlay) {
            var $card = this._elementToCard(element);
            var videoUrl = null;

            if ($card.length) {
                videoUrl = this._cardVideoUrl(element);
                $card.siblings().removeClass('card--active');
                $card.addClass('card--active');

                autoPlay = autoPlay !== false;

                if (autoPlay) {
                    this._scrollCardIntoView($card);
                }

                this.playVideo(videoUrl, autoPlay);
            } else {
                // Last card was reached. Remove play status and do nothing
                this.$cards.removeClass('card--active');
            }

            this._verifyActiveIndex();
            return videoUrl;
        },

        /**
         * @param {JQuery} $card
         * @private
         */
        _scrollCardIntoView: function($card) {
            var contentEl = this.$videosList.find('.simplebar-content')[0];
            var viewportWidth = contentEl.clientWidth;
            var maxScrollLeft = contentEl.scrollWidth - contentEl.clientWidth;

            var cardLeft = Math.ceil($card.position().left + contentEl.scrollLeft);
            var cardWidth = $card.width();
            var cardRight = cardLeft + cardWidth;

            if (cardLeft < contentEl.scrollLeft || cardRight > viewportWidth) {
                var scrollPos = Math.max(0, cardLeft - (viewportWidth - cardWidth) / 2);

                if (contentEl.scrollTo) {
                    contentEl.scrollTo({
                        left: Math.min(scrollPos, maxScrollLeft),
                        behavior: 'smooth'
                    });
                } else { // IE and Edge case
                    contentEl.scrollTo = Math.min(scrollPos, maxScrollLeft);
                }
            }
        },

        /** @private */
        _verifyActiveIndex: function() {
            var cardIndex = this.$cards.index(this.$activeCard);
            var $element = this.$element;

            if (cardIndex === 0) {
                $element.removeClass('top-videos--last').addClass('top-videos--first');
            } else if (cardIndex <= 0 || cardIndex === this.$cards.length - 1) {
                $element.removeClass('top-videos--first').addClass('top-videos--last');
            } else {
                $element.removeClass('top-videos--first top-videos--last');
            }
        },

        /**
         * Will be called when autoplay is disabled and the user click on the first video.
         * @private
         */
        _onEmbedFirstClick: function(e) {
            this._listenForPlayerClick(false);

            /** @type {{url: string, autoPlay: boolean}} */
            var videoMeta = this.$playbackArea.data('video-meta');

            if (!videoMeta.autoPlay) {
                // Video didn't start automatically when loaded. Track start on click.
                // It was a video without autoPlay user clicked manually to start it
                this.triggerHandler('clickPlay', videoMeta.url);
            }
        },

        _onWindowBlur: function(e) {
            if (!this.autoClickDirty && document.activeElement instanceof HTMLIFrameElement) {
                var $embedFrame = this.$playbackArea.find('iframe');

                if ($embedFrame.length && $embedFrame[0] === document.activeElement) {
                    this._onEmbedFirstClick(e);
                }
            }
        },
    };

    // Hook all top videos modules on the page
    $('.top-videos').topVideos();
})(jQuery);
